import React from "react";
import {RouterProvider} from "react-router";
import {router} from "./routing/router";
import {ThemeModeProvider} from "./styling/ThemeContext";

function App() {
    return (
        <React.StrictMode>
            <ThemeModeProvider>
                <RouterProvider router={router}/>
            </ThemeModeProvider>
        </React.StrictMode>
    );
}

export default App;
